// extracted by mini-css-extract-plugin
export var button = "_c9-4";
export var hasDarkBackground = "_c9-7";
export var hasLightBackground = "_c9-6";
export var iconWrapper = "_c9-0";
export var large = "_c9-2";
export var medium = "_c9-1";
export var small = "_c9-5";
export var xsmall = "_c9-3";